import { useAppDispatch } from "../../redux/hooks/hooks";
import { OperationCompletedPanel } from "../layout/OperationCompletedPanel";
import { formatMessage } from "../../utils/helpers/LanguageHelper";
import { PrimaryButton } from "@fluentui/react/lib/Button";
import { navigate } from "../../redux/feature/general/navigation-slice";
import { DOCUMENTS_LISTS } from "../../utils/constants/navigation";
import React from "react";

export const DocumentNonRootError = () => {
  const dispatch = useAppDispatch();
  return (
    <OperationCompletedPanel
      message={formatMessage("cof.validation.info.notrootdocument")}
      alt={formatMessage("cof.validation.info.notrootdocument")}
      icon="/assets/illustrations/oopsRoot.svg"
      styles={{ container: { minHeight: "70vh" } }}
    >
      <PrimaryButton
        text={formatMessage("cof.opendocuments.opendocument")}
        onClick={() => dispatch(navigate(DOCUMENTS_LISTS))}
      />
    </OperationCompletedPanel>
  );
};
